export interface DateRangeInterface {
  startDate: Date;
  endDate: Date;
}
